export enum DefaultOption {
  ALL = 'ALL'
}

export interface ResourcesParams {
  resourceTypeId: string;
}

export interface ResourceFilterBarFormState {
  resource: string;
  product: string;
  grade: string;
  search: string;
}

export interface ResourceFilterBarSelectOptions {
  resourceOptions: { display: string; value: string }[];
  productOptions: string[];
  gradeOptions: string[];
}

export interface LessonPreviewWeekData {
  id: number;
  week: number;
  title: string;
  keys: string[];
  video: string;
  url: string;
  thumbnail: string;
  theme: {
    name: string;
    icon: string;
  };
  Monday: LessonPreviewWeekData[];
  Tuesday: LessonPreviewWeekData[];
  Wednesday: LessonPreviewWeekData[];
  Thursday: LessonPreviewWeekData[];
  Friday: LessonPreviewWeekData[];
}
